export default __webpack_public_path__ + "static/media/iusd.b124fcce.svg";